var React = require('react');

function X1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"X1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":0},React.createElement("polygon",{"points":"46.01 25.69 25.59 0.34 0 1.98 29.83 41.87 46.01 25.69","fill":"#f47643"})),React.createElement("polygon",{"points":"83.36 81.99 57.43 38.46 84.77 1.05 60.05 0 3.28 77.69 28 78.74 44.13 56.66 58.64 80.94 83.36 81.99","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

X1.defaultProps = {"viewBox":"0 0 84.77 81.99"};

module.exports = X1;

X1.default = X1;
